module.exports = __webpack_public_path__ + "static/media/ChessVR-Poster.89c009b2.jpg";